<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(bomSummaryLoaderKey)" [suiIsLoading]="bomSummaryLoaderKey" class="dialog-content">
    <div class="header">
        <div class="header-name">
            <span class="header-name_content">BOM summary</span>
            <button (click)="clear()" matDialogClose windeClose>
                <sui-svg-icon icon="cross"/>
            </button>
        </div>

        <winde-tabs-nav
                (tabChanged)="changeTab($event)"
                *ngIf="tabsToShow.length > 0"
                [activeTab]="currentTab"
                [customClass]="'tabs-nav--doc-tabs mb-1'"
                [tabsList]="tabsToShow"
                [translationPrefix]="'project.reportsTabs'"
        >
        </winde-tabs-nav>
    </div>

    <div class="content bom-modal-body">
        <div *ngIf="bomSummaryDTO && currentTab === 0" class="pt-3">
            <ng-container *ngFor="let summaryPerLayer of bomSummaryDTO.summaryPerLayer; let layerIndex = index">
                <h4 *ngIf="historyService.logicalTopology?.layersModeEnabled">
                    {{ summaryPerLayer.layerName }}
                </h4>

                <!-- Products-->
                <ng-container *ngIf="summaryPerLayer.typesCount">
                    <h6>Device types:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.typeName]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- Product services -->
                <ng-container *ngIf="summaryPerLayer.serviceTypesSelect && summaryPerLayer.serviceYearsSelect">
                    <h6 id="servicePlanTableHeader">SikluCare Service & Support Plans:</h6>

                    <div class="select-plan">
                        <sui-select-enum-component
                                [config]="summaryPerLayer.serviceTypesSelect"
                        ></sui-select-enum-component>
                        <sui-select-enum-component
                                *ngIf="summaryPerLayer.serviceTypesSelect.value !== productServiceTypeEnum.NONE"
                                [config]="summaryPerLayer.serviceYearsSelect"
                        ></sui-select-enum-component>
                    </div>

                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            *ngIf="summaryPerLayer.servicesCount"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.services]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- Antennas -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.ANTENNA]">
                    <h6>Antenna:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.ANTENNA]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- Sector licenses -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.SECTOR_LICENSE]">
                    <h6>Sector License:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.SECTOR_LICENSE]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- Capacity licenses -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.SOFTWARE_UPGRADE]">
                    <h6>Capacity License:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.SOFTWARE_UPGRADE]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- Mounting kit -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.MK]">
                    <h6>Mounting kit:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.MK]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- POE -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.POWER_INJECTORS]">
                    <h6>POE:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.POWER_INJECTORS]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- SRG -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.SRG]">
                    <h6>Surge protectors:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.SRG]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- SFP -->
                <ng-container *ngIf="summaryPerLayer.accessoriesCount[productAccessoryEnum.SFP]">
                    <h6>SFP:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.SFP]]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <!-- Licenses -->
                <ng-container
                        *ngIf="
                        summaryPerLayer.accessoriesCount[productAccessoryEnum.OPT_AES] ||
                        summaryPerLayer.accessoriesCount[productAccessoryEnum.OPT_PSE] ||
                        summaryPerLayer.accessoriesCount[productAccessoryEnum.OPT_L2] ||
                        summaryPerLayer.accessoriesCount[productAccessoryEnum.OPT_EXTENDMM] ||
                        summaryPerLayer.accessoriesCount[productAccessoryEnum.OPT_SYNC]
                    "
                >
                    <h6>Licenses:</h6>
                    <winde-bom-summary-record-table
                            (discountChanged)="discountChanged($event)"
                            [currencyCode]="bomSummaryDTO.currencyCode"
                            [summaryRecordsList]="[
                            summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_AES],
                            summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_PSE],
                            summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_L2],
                            summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_EXTENDMM],
                            summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_SYNC]
                        ]"
                    ></winde-bom-summary-record-table>
                </ng-container>

                <div
                        *ngIf="summaryPerLayer.totalCostForLayer && historyService.logicalTopology.layersModeEnabled"
                        class="clearfix"
                        style="margin: 20px"
                >
                    <h6 class="float-right">
                        Total cost per layer:
                        <winde-single-price-show
                                [currency]="bomSummaryDTO.currencyCode"
                                [price]="summaryPerLayer.totalCostForLayer"
                                class="d-inline-block align-top"
                        ></winde-single-price-show>
                    </h6>
                </div>
            </ng-container>
        </div>

        <div *ngIf="bomSummaryDTO && currentTab === 1" class="pt-3">
            <ng-container *ngFor="let summaryPerLayer of bomSummaryDTO.summaryPerLayer; let layerIndex = index">
                <h4 *ngIf="historyService.logicalTopology?.layersModeEnabled">
                    {{ summaryPerLayer.layerName }}
                </h4>

                <div class="p-2">
                    <ng-container *ngIf="summaryPerLayer.installedTypesCount">
                        <h6>Device types:</h6>
                        <div class="grid">
                            <div class="grid-row">
                                <div class="grid-row__cell">Name</div>
                                <div class="grid-row__cell">Description</div>
                                <div class="grid-row__cell">Quantity</div>
                            </div>

                            <ng-container *ngFor="let value of summaryPerLayer.typeName | keyvalue">
                                <div *ngIf="value.value.installedCount" class="grid-row">
                                    <div [windeProductNameLink]="value.value.name" class="grid-row__cell">{{ value.value.name }}</div>
                                    <div class="grid-row__cell">{{ value.value.description }}</div>
                                    <div class="grid-row__cell">{{ value.value.installedCount }}</div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- Sector licenses -->
                    <ng-container *ngIf="summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.SECTOR_LICENSE]">
                        <h6>Sector License:</h6>
                        <winde-bom-summary-record-table
                                (discountChanged)="discountChanged($event)"
                                [currencyCode]="bomSummaryDTO.currencyCode"
                                [showInstalled]="true"
                                [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.SECTOR_LICENSE]]"
                        ></winde-bom-summary-record-table>
                    </ng-container>

                    <!-- Capacity licenses -->
                    <ng-container *ngIf="summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.SOFTWARE_UPGRADE]">
                        <h6>Capacity License:</h6>
                        <winde-bom-summary-record-table
                                (discountChanged)="discountChanged($event)"
                                [currencyCode]="bomSummaryDTO.currencyCode"
                                [showInstalled]="true"
                                [summaryRecordsList]="[summaryPerLayer.accessoriesMap[productAccessoryEnum.SOFTWARE_UPGRADE]]"
                        ></winde-bom-summary-record-table>
                    </ng-container>

                    <!-- Licenses -->
                    <ng-container
                            *ngIf="
                            summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.OPT_AES] ||
                            summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.OPT_PSE] ||
                            summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.OPT_L2] ||
                            summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.OPT_EXTENDMM] ||
                            summaryPerLayer.installedAccessoriesCount[productAccessoryEnum.OPT_SYNC]
                        "
                    >
                        <h6>Licenses:</h6>
                        <winde-bom-summary-record-table
                                (discountChanged)="discountChanged($event)"
                                [currencyCode]="bomSummaryDTO.currencyCode"
                                [showInstalled]="true"
                                [summaryRecordsList]="[
                                summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_AES],
                                summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_PSE],
                                summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_L2],
                                summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_EXTENDMM],
                                summaryPerLayer.accessoriesMap[productAccessoryEnum.OPT_SYNC]
                            ]"
                        ></winde-bom-summary-record-table>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="footer">
        <div *ngIf="bomSummaryDTO" class="total-price-block">
            <span class="total-price">Total:</span>
            <winde-single-price-show
                    [currency]="bomSummaryDTO.currencyCode"
                    [price]="bomSummaryDTO.totalCost"
                    class="d-inline-block align-top total-price"
            ></winde-single-price-show>
        </div>
        <div class="export-button">
            <button
                    (click)="exportBomSummaryInSalesForceFormat()"
                    *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                    [disabled]="!bomSummaryDTO?.summaryPerLayer?.length"
                    windeGreen
            >
                Export BOM summary in SalesForce format
            </button>
            <button (click)="exportBomSummary()" [disabled]="!bomSummaryDTO?.summaryPerLayer?.length" windeGreen>Export BOM summary</button>
        </div>
    </div>
</div>
